import Shipping from "./shipping";
import { RDStation, Zendesk, widgetWhatsapp } from "./vndaComponents";
import Webforms from "./webforms";

window.$window = $(window);
window.$body = $("body");
window.page = $body.data("page");
window.$header = $("#header");
window.$wrapper = $("#wrapper");
window.spaceToHeaderFixed;
window.language = $("html").attr("lang");
window.timeTransitionDefault = 350;
window.texts = [];

texts["pt-BR"] = {
  quantity: "quantidade",
  price: "preço",
  cart_empty: "O seu carrinho está vazio",
  go_product: "Ir para a página do produto",
  btn_edit_cart: "Editar pedido",
  btn_checkout: "Finalizar pedido",
  btn_success: "Adicionado!",
  errorsTxt: {
    withoutSku: "Selecione um atributo para o produto",
  },
};

function getText(key, subKey) {
  if (typeof subKey == "undefined") {
    return texts[language][key];
  } else {
    return texts[language][key][subKey];
  }
}

window.store = {
  config: {
    // Seletor do botão de comprar
    selectorBtnBuy: '[data-action="add-cart"]',
    selectorBtnBuyAssinatura: '[data-action="add-cart-assinatura"]',
    // Seletor do elemento que engloba um produto
    selectorWrapperProduct: "[data-box-produto]",
    selectorWrapperProductAssinatura: "[data-box-produto-assinatura]",
    selectorFormProduct: "[data-form-product]",
    selectorFormProductAssinatura: "[data-form-product-assinatura]",
    // Se a store tem versão internacional ou não
    hasInternacionalVersion: false,
    errorsTxt: {
      withoutSku: getText("errorsTxt", "withoutSku"),
    },
    // configuração de comportamento ao add um produto
    addToCartOpenCartpopup: true,
    addToCartOpenCartpopupMobile: true,
    cartCount: {
      selector: "[data-cart-count]",
      attr: "[data-cart-count-attr]",
      text: "[data-cart-item-text]",
    },
  },
  formatMoney: function (value) {
    // FORMATA UM VALOR
    return (
      "R$ " +
      value
        .toFixed(2)
        .replace(".", ",")
        .replace(/(\d)(?=(\d{3})+\,)/g, "$1.")
    );
  },
  urlencodeFormData: function (formData) {
    let string = '';

    function encode(s) {
      return encodeURIComponent(s).replace(/%20/g, '+');
    }

    for (const pair of formData.entries()) {
      if (typeof pair[1] == 'string') {
        string += (string ? '&' : '') + encode(pair[0]) + '=' + encode(pair[1]);
      }
    }
    return string;
  },
  validateQuantity: function (_val) {
    // VALIDA SE A QUANTIDADE INFORMADA É UM NÚMERO
    if (!isNaN(_val)) {
      if (parseInt(_val) > 0) {
        return true;
      }
    }

    return false;
  },
  getClearNumber: function (_val) {
    // RETORNA UM NÚMERO LIMPO COMO INT
    if (!isNaN(_val)) {
      clearNumber = parseInt(_val);

      return clearNumber;
    }

    return false;
  },
  findVariant: function (properties, variant_list) {
    return variant_list.filter(function (variant) {
      var match = true
      for (var property_key in properties) {
        var property1 = variant.properties['property1']
        var property2 = variant.properties['property2']
        var property3 = variant.properties['property3']

        if (property1 && property_key === property1.name) {
          var desired_property = property1.value
        } else if (property2 && property_key === property2.name) {
          var desired_property = property2.value
        } else if (property3 && property_key === property3.name) {
          var desired_property = property3.value
        }

        if (desired_property !== properties[property_key]) {
          match = false
        }
      }
      return match
    })
  },
  validateFormProduct: function (_$form) {
    // VALIDA O FORM DE PRODUTO PARA VER SE O PRODUTO PODE SER ADICIONADO
    var $parent = _$form.closest("[data-box-produto]");
    var $btnComprar = _$form.find('[data-action="add-cart"]');
    var validated = true;
    var errorsTxt = [];

    if ($btnComprar.data("available") == "false") {
      validated = false;
      errorsTxt.push("");
    } else {
      //  verifica se o sku foi selecionado
      if (_$form.find('[name="sku"]').val() == "") {
        validated = false;
        errorsTxt.push("Selecione um atributo para o produto");
      }

      //  verifica se a quantidade é válida
      //console.log(_$form.find('input[name="quantity"]').val());
      if (_$form.find('input[name="quantity"]').val() <= 0) {
        //console.log("qtd invalida");
        validated = false;
        errorsTxt.push("Quantidade indisponível");
      }
    }

    return { validated: validated, errors: errorsTxt };
  },
  setRespValidateProduct: function (_resp, _$form, _$boxResponse) {
    // var $boxResult = _$form.find('.resp-validate');
    var $boxResult = _$boxResponse;
    var htmlErrors = "";

    if (_resp.validated) {
      $boxResult.empty();
    } else {
      for (var i = _resp.errors.length - 1; i >= 0; i--) {
        htmlErrors += '<span class="msg error">' + _resp.errors[i] + "</span>";
      }

      $boxResult.html(htmlErrors);
    }
  },
  addItemResultDefault: function (_$form, _typeResult, _result, _$boxResponse) {
    console.log("addItemResultDefault")
    var _this = this;
    if (_typeResult == "produto-adicionado") {
      var $btnComprar = _$form.find(_this.config.selectorBtnBuy);

      $btnComprar.addClass("success").html("Produto adicionado!");

      setTimeout(function () {
        // _$form.find('.msg-response').slideUp(350);
        $btnComprar
          .removeClass("success")
          .html($btnComprar.data("text-available"));
      }, 3500);

      setTimeout(function () {
        window.location.href = urlCart;
      }, 150);
    } else if (_typeResult == "erro-adicionar") {
      var errorText = JSON.parse(_result.responseText);

      if (typeof _$boxResponse != "undefined" && _$boxResponse.length > 0) {
        //console.info(errorText);

        _$boxResponse.addClass("error");
        _$boxResponse.removeClass("success");

        _$boxResponse.find("span").html(errorText.error);
        _$boxResponse.slideDown(350);

        setTimeout(function () {
          _$boxResponse.slideUp(350);
        }, 3500);
      }
    }
  },
  addItemResultDefaultAssinatura: function (
    _$form,
    _typeResult,
    _result,
    _$boxResponse
  ) {
    var _this = this;
    if (_typeResult == "produto-adicionado") {
      var $btnComprar = _$form.find(_this.config.selectorBtnBuyAssinatura);

      $btnComprar.addClass("success").html("Adicionado!");

      setTimeout(function () {
        // _$form.find('.msg-response').slideUp(350);
        $btnComprar
          .removeClass("success")
          .html($btnComprar.data("text-available"));
      }, 3500);

      setTimeout(function () {
        window.location.href = urlAssinaturaCart;
      }, 150);
    } else if (_typeResult == "erro-adicionar") {
      if (typeof _result == "object") {
        var errorText = _result;
      } else {
        var errorText = JSON.parse(_result);
      }

      if (typeof _$boxResponse != "undefined" && _$boxResponse.length > 0) {
        //console.info(errorText);

        _$boxResponse.addClass("error");
        _$boxResponse.removeClass("success");

        _$boxResponse.find("span").html(errorText.error);
        _$boxResponse.slideDown(350);
      }
    }
  },
  addItem: function (_$form, _$parent, addItemResult) {
    var _this = this;
    var $btnComprar = _$parent.find('[data-action="add-cart"]');
    var urlAdd = "/carrinho/adicionar";
    var urlUpdate = "/carrinho";
    var url = urlAdd;
    var form = _$form.serialize();
    var $boxResponse = _$parent.find(
      "[data-form-product] .msg-response:not(.resp-validate)"
    );

    console.info('addItem');
    console.info('addItem', _$form.serializeArray());

    if (!$btnComprar.hasClass("adding")) {
      $.ajax({
        url: url,
        type: "POST",
        dataType: "json",
        data: form,
        beforeSend: function () {
          $btnComprar.addClass("adding");
        },
      })
        .done(function (resp) {
          console.log("success");
          console.info(resp);

          if (typeof template_store.addItemResult == "function") {
            template_store.addItemResult(
              _$form,
              "produto-adicionado",
              resp,
              $boxResponse
            );
          } else {
            template_store.addItemResultDefault(
              _$form,
              "produto-adicionado",
              resp,
              $boxResponse
            );
          }
        })
        .fail(function (resp) {
          //console.log("error");
          //console.error(resp);
          //console.error(resp.responseText);
          //console.error(resp.responseText.error);

          if (typeof template_store.addItemResult == "function") {
            template_store.addItemResult(
              _$form,
              "erro-adicionar",
              resp,
              $boxResponse
            );
          } else {
            template_store.addItemResultDefault(
              _$form,
              "erro-adicionar",
              resp,
              $boxResponse
            );
          }
        })
        .always(function () {
          //console.log("complete");
          $btnComprar.removeClass("adding");
        });
    }
  },
  addItemAssinatura: function (_$form, _$parent, addItemResult) {
    var _this = this;
    var $btnComprar = _$parent.find(store.config.selectorBtnBuyAssinatura);
    var url = urlAssinaturaCartAdd;
    var form = _$form.serialize();
    var $boxResponse = _$parent.find(
      store.config.selectorFormProductAssinatura +
      " .msg-response:not(.resp-validate)"
    );
    var data = {};

    data.subscription_item = {
      quantity: _$form.find('[name="quantity"]').val(),
      sku: _$form.find('[name="sku"]').val(),
      extra: {
        vindi_plan_id: _$form.find('[name="extra[vindi_plan_id]"]').val(),
      },
    };

    //console.info('addItemAssinatura');
    //console.info('addItemAssinatura', data);
    //console.info('addItemAssinatura', JSON.stringify(data));

    if (!$btnComprar.hasClass("adding")) {
      $.ajax({
        url: url,
        type: "POST",
        // dataType: 'json',
        contentType: "application/json",
        data: JSON.stringify(data),
        xhrFields: { withCredentials: true },
        beforeSend: function () {
          $btnComprar.addClass("adding");
        },
      })
        .done(function (resp) {
          //console.log("success");
          //console.info(resp);

          if (typeof template_store.addItemResult == "function") {
            template_store.addItemResult(
              _$form,
              "produto-adicionado",
              resp,
              $boxResponse
            );
          } else {
            template_store.addItemResultDefaultAssinatura(
              _$form,
              "produto-adicionado",
              resp,
              $boxResponse
            );
          }
        })
        .fail(function (xhr, status, error) {
          //console.log("error");
          //console.error(xhr);
          //console.error(status);
          //console.error(error);

          var resp = {
            error:
              "Houve um problema ao adicionar. Tente mais tarde ou entre em contato.",
          };

          if (typeof template_store.addItemResult == "function") {
            template_store.addItemResult(
              _$form,
              "erro-adicionar",
              resp,
              $boxResponse
            );
          } else {
            template_store.addItemResultDefaultAssinatura(
              _$form,
              "erro-adicionar",
              resp,
              $boxResponse
            );
          }
        })
        .always(function () {
          //console.log("complete");
          $btnComprar.removeClass("adding");
        });
    }
  },
  deleteItem: function (_itemId, _$item, removeItemResult) {
    var _this = this;

    if (!_$item.hasClass("removing")) {
      $.ajax({
        url: "/carrinho",
        type: "POST",
        dataType: "json",
        data: {
          _method: "delete",
          item_id: _itemId,
        },
        beforeSend: function () {
          _$item.addClass("removing");
        },
      })
        .done(function (_cart) {
          //console.log("success");

          if ($body.width() > 768) {
            if (store.config.addToCartOpenCartpopup) {
              template_store.headerCart.loadCart(_cart);
              template_store.headerCart.hide();
            }
          } else {
            if (store.config.addToCartOpenCartpopupMobile) {
              template_store.headerCart.loadCart(_cart);
              template_store.headerCart.hide();
            }
          }

          if (typeof removeItemResult == "function") {
            removeItemResult(_$item, _cart);
          }
        })
        .fail(function (error) {
          //console.log("erro ao remover", error.responseText);
        })
        .always(function () {
          _$item.removeClass("removing");
        });
    }
  },
  setMsgResponse: function (_msg, _type, _$parent) {
    /*
      O tipo pode conter um dos 3 valores: success, warning, error ou CLEAR.
      O type CLEAR limpa as mensagens e faz sumir a mensagem
    */

    // Verifica se não há mais de uma mensagem
    // caso tenha, gera um html para cada mensagem
    if (Array.isArray(_msg)) {
      var msgArr = _msg;
      _msg = "";
      for (var i = msgArr.length - 1; i >= 0; i--) {
        _msg += '<span class="msg error">' + msgArr[i] + "</span>";
      }
    }

    _$parent
      .find("[data-msg-retorno]")
      .removeClass("success")
      .removeClass("warning")
      .removeClass("error");

    _$parent.find("[data-msg-retorno] [data-msg]").empty();

    if (_type != "clear") {
      _$parent.find("[data-msg-retorno]").addClass(_type);
      _$parent.find("[data-msg-retorno] [data-msg]").html(_msg);
    }
  },
  updateCartCount: function (_itemsCount) {
    var _this = this;

    $(_this.config.cartCount.selector).empty().text(_itemsCount);

    $(_this.config.cartCount.attr).data("cart-count-attr", _itemsCount);
    $(_this.config.cartCount.attr).attr("data-cart-count-attr", _itemsCount);

    $(_this.config.cartCount.attr).html(_itemsCount);
    $(_this.config.cartCount.text).html(_itemsCount);
    $(_this.config.cartCount.textLabel).html(
      _itemsCount > 1 ? "itens" : "item"
    );

    if (_itemsCount > 0) {
      $("[data-cart-body]").parent().parent().addClass("active");
    } else {
      $("[data-cart-body]").parent().parent().removeClass("active");
    }

    setTimeout(function () {
      $("[data-cart-body]").parent().parent().removeClass("active");
    }, 3500);
  },
  getCartCount: function () {
    async function getCartItens() {
      let itens;

      try {
        itens = await $.ajax({
          url: '/carrinho/itens',
          type: 'GET',
          dataType: 'text'
        });

        return itens;
      } catch (error) {
        console.error(error);
      }
    }

    if ($(store.config.cartCount.selector).length > 0) {
      getCartItens().then((total) => {
        var itens = Number.isInteger(parseInt(total));
        if (itens) {
          $(store.config.cartCount.attr).attr('data-cart-count-attr', total);
          $(store.config.cartCount.selector).html(total);

          var $boxCart = $('[data-cart-body]');

          if ($boxCart.length > 0) {
            if (total > 0) {
              template_store.headerCart.loadCart();
            } else {
              $boxCart.html('<div class="empty"><p>Seu carrinho está vazio...</p></div>');
            }
          }
        }
      });
    };
  },
  submitForm: function (_$form) {
    _$form.find('[name="reply_to"]').val(_$form.find('[name="email"]').val());

    if (!_$form.hasClass("sending")) {
      $.ajax({
        url: "/webform",
        type: "POST",
        data: _$form.serialize(),
        beforeSend: function () {
          _$form.addClass("sending");
        },
      })
        .done(function () {
          // console.info('foi');
          // store.setMsgResponse('Mensagem enviada com sucesso!', 'success', _$form);
          _$form
            .find("[data-msg-retorno] [data-msg-success]")
            .addClass("visible");
          _$form
            .find("[data-msg-retorno] [data-msg-error]")
            .removeClass("visible");
          _$form.find("button[type=submit]").text("Enviado");

          setTimeout(function () {
            _$form.find("button[type=submit]").text("Enviar");
          }, 3500);
          _$form[0].reset();
        })
        .fail(function () {
          // console.info('foi, mas deu ruim');
          _$form
            .find("[data-msg-retorno] [data-msg-success]")
            .removeClass("visible");
          _$form
            .find("[data-msg-retorno] [data-msg-error]")
            .addClass("visible");
          _$form.find("button[type=submit]").text("Falha ao enviar");
          setTimeout(function () {
            _$form.find("button[type=submit]").text("Enviar");
          }, 3500);
          // store.setMsgResponse('Houve um problema ao enviar sua mensagem, tente novamente! Ou entre em contato conosco pelo telefone (21) 99644-6925 ', 'error', $form);
        })
        .always(function () {
          //console.log("complete");
          _$form.removeClass("sending");
        });
    }
  },
  login: {
    validateLogin: function (_$form) {
      var validated = true;
      var errorsTxt = [];

      if (_$form.find('[name="email"]').val() == "") {
        validated = false;
        errorsTxt.push("Informe seu email!");
      }

      if (_$form.find('[name="password"]').val() == "") {
        validated = false;
        errorsTxt.push("Informe a senha!");
      }

      return { validated: validated, errors: errorsTxt };
    },
    validateRegister: function (_$form) {
      var validated = true;
      var errorsTxt = [];

      if (_$form.find('[name="email"]').val() == "") {
        validated = false;
        errorsTxt.push("Informe seu email!");
      }

      if (_$form.find('[name="password"]').val() == "") {
        validated = false;
        errorsTxt.push("Informe uma senha!");
      }

      if (_$form.find('[name="password"]').val() != "") {
        var pass = _$form.find('[name="password"]').val();
        var confirmationPass = _$form
          .find('[name="password_confirmation"]')
          .val();

        if (pass != confirmationPass) {
          validated = false;
          errorsTxt.push("Senha e confirmação são diferentes!");
        }
      }

      return { validated: validated, errors: errorsTxt };
    },
    validateRecover: function (_$form) {
      var validated = true;
      var errorsTxt = [];

      if (_$form.find('[name="email"]').val() == "") {
        validated = false;
        errorsTxt.push("Informe seu email!");
      }

      return { validated: validated, errors: errorsTxt };
    },
    logar: function (_$form) {
      if (!_$form.hasClass("sending")) {
        $.ajax({
          url: "/entrar",
          type: "POST",
          dataType: "json",
          data: _$form.serialize(),
          beforeSend: function () {
            _$form.addClass("sending");
          },
        })
          .done(function (resp) {
            //console.log("success", resp);

            if (resp.error) {
              store.setMsgResponse(resp.error, "error", _$form);
            }

            if (resp.client) {
              window.location.href = resp.redirect_to;
            }
          })
          .fail(function (resp) {
            //console.error("error", error.responseText);
          })
          .always(function () {
            //console.log("complete");
            _$form.removeClass("sending");
          });
      }
    },
    recoverPassord: function (_$form) {
      if (!_$form.hasClass("sending")) {
        $.ajax({
          url: "/recuperar_senha",
          type: "POST",
          dataType: "json",
          data: _$form.serialize(),
          beforeSend: function () {
            _$form.addClass("sending");
          },
        })
          .done(function (resp) {
            //console.log("success", resp);

            if (resp.error) {
              store.setMsgResponse(resp.error, "error", _$form);
            }

            if (resp.ok) {
              store.setMsgResponse(resp.ok, "success", _$form);
            }

            /*if (resp.client) {
            window.location.href = resp.redirect_to;
          }*/
          })
          .fail(function (resp) {
            //console.error("error", error.responseText);
          })
          .always(function () {
            //console.log("complete");
            _$form.removeClass("sending");
          });
      }
    },
  },
};

window.template_store = {
  headerCart: {
    loadCart: async function (_cart) {
      var cartBody = document.querySelectorAll('[data-cart-body]');
      if (_cart) store.updateCartCount(_cart.items_count);

      try {
        const response = await fetch('/carrinho/popup')

        if (response.ok) {
          const html = await response.text()
          cartBody.forEach(cart => {
            cart.innerHTML = '';
            cart.innerHTML = html;
          })
        }
      } catch (error) {
        console.log('Erro ao executar funções do carrinho', error)
      }
    },
    show: function () {
      var $cartBody = $('[data-cart-body]');

      $cartBody.addClass("active");

      $("html,body").animate({ scrollTop: 0 }, "250");

      setTimeout(function () {
        $cartBody.removeClass("active");
      }, 3500);
    },
  },
  setMenuMobile: function () {
    const btnOpenMenu = document.querySelector('[data-action="open-menu-mobile"]');
    const menuMobile = document.getElementById('menu-mobile');
    const btnSubmenus = document.querySelectorAll('[data-target]');
    const wrapper = document.getElementById('wrapper');
    const overlay = document.createElement('div');
    overlay.classList.add('overlay');

    /* Evento para abrir e recolher submenus */
    btnSubmenus.forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        const target = document.querySelector(e.currentTarget.dataset.target);
        const panel = e.currentTarget.closest('.opened');

        if (e.currentTarget.classList.contains('next')) {
          target.classList.add('opened');
          target.classList.remove('hidden');
          panel.classList.remove('opened');
          panel.classList.add('submenu-opened');
        } else {
          target.classList.add('opened');
          panel.classList.remove('opened');
          target.classList.remove('submenu-opened');
          setTimeout(() => {
            panel.classList.add('hidden');
          }, 600);
        }
      });
    });

    /* Evento para abrir o menu */
    btnOpenMenu.addEventListener('click', () => {
      document.documentElement.classList.add('menu-opened');
      document.body.classList.add('menu-opened');
      menuMobile.classList.add('opened');
      menuMobile.style.display = 'block';
      wrapper.appendChild(overlay);
      overlay.classList.add('bg');
    });

    /* Evento para fechar o menu */
    overlay.addEventListener('click', () => {
      menuMobile.classList.remove('opened');
      overlay.classList.remove('bg');
      setTimeout(() => {
        wrapper.removeChild(overlay);
        document.body.classList.remove('menu-opened');
        document.documentElement.classList.remove('menu-opened');
        menuMobile.style.display = 'none';
      }, 500);
    });
  },
  submitFormNotify: function (_$form) {
    var formData = _$form.serialize();

    if (!_$form.hasClass("sending")) {
      $.ajax({
        url: _$form.attr("action"),
        type: "post",
        dataType: "json",
        data: formData,
        beforeSend: function () {
          _$form.addClass("sending");
        },
      })
        .done(function (resp) {
          //console.log("success");
          //console.info(resp);

          var msgSuccess =
            "Você receberá um e-mail quando o produto estiver disponível";

          // Envia um email para o cliente saber que o usuário solicitou o avise-me
          $.ajax({
            url: "/webform",
            type: "POST",
            data: {
              key: _$form.find('[name="key"]').val(),
              reply_to: _$form.find('[name="email"]').val(),
              email: _$form.find('[name="email"]').val(),
              product_name: _$form.find('[name="nome"]').val(),
              referencia: _$form.find('[name="referencia"]').val(),
              sku: _$form.find('[name="sku"]').val(),
            },
          })
            .done(function (resp) {
              _$form.find("button[type=submit]").text("Enviado");
              setTimeout(function () {
                _$form.find("button[type=submit]").text("Enviar");
              }, 3500);
              _$form[0].reset();
            })
            .fail(function (error) {
              _$form.find("button[type=submit]").text("Falha ao enviar");
              setTimeout(function () {
                _$form.find("button[type=submit]").text("Enviar");
              }, 3500);
            })
            .always(function () { });

          if (resp.error) {
            _$form.find(".msg-response").removeClass("happy").addClass("error");
            _$form.find(".msg-response span").html(resp.error);
            _$form.find(".msg-response").slideDown(350);

            setTimeout(function () {
              _$form
                .find(".msg-response")
                .removeClass("happy")
                .removeClass("error");
              _$form.find(".msg-response span").empty();
            }, 3500);
          } else {
            _$form.find(".msg-response").addClass("happy").removeClass("error");
            _$form.find(".msg-response span").html(msgSuccess);

            setTimeout(function () {
              _$form
                .find(".msg-response")
                .removeClass("happy")
                .removeClass("error");
              _$form.find(".msg-response span").empty();
            }, 3500);
          }
        })
        .fail(function (resp) {
          //console.log("error");
          //console.error(resp);
          //console.error(resp.responseText);
          //console.error(resp.responseText.error);

          var errorText = JSON.parse(resp.responseText);
          //console.info(errorText);

          _$form.find(".msg-response").removeClass("happy");
          _$form.find(".msg-response span").html(errorText.error);
          _$form.find(".msg-response").slideDown(350);

          setTimeout(function () {
            $_$form.find(".msg-response").slideUp(350);
          }, 3500);
        })
        .always(function () {
          _$form.removeClass("sending");
        });
    }
  },
  addItemResult: function (_$form, _typeResult, _result, _$boxResponse) {
    var _this;

    if (_typeResult == "produto-adicionado") {
      var $btnComprar = $(store.config.selectorBtnBuy);

      $btnComprar.addClass("success").html(getText(language));

      setTimeout(function () {
        // _$form.find('.msg-response').slideUp(350);
        $btnComprar
          .removeClass("success")
          .html($btnComprar.data("text-available"));
      }, 3500);

      if ($body.width() > 768) {
        if (store.config.addToCartOpenCartpopup) {
          template_store.headerCart.loadCart(_result);
          template_store.headerCart.show();
        } else {
          setTimeout(function () {
            window.location.href = urlCart;
          }, 150);
        }
      } else {
        if (store.config.addToCartOpenCartpopupMobile) {
          template_store.headerCart.loadCart(_result);
          template_store.headerCart.show();
        } else {
          setTimeout(function () {
            window.location.href = urlCart;
          }, 150);
        }
      }
    } else if (_typeResult == "erro-adicionar") {
      var errorText = JSON.parse(_result.responseText);

      if (typeof _$boxResponse != "undefined" && _$boxResponse.length > 0) {
        $("html,body").animate(
          {
            scrollTop: _$boxResponse.offset().top,
          },
          "250"
        );

        //console.info(errorText);

        _$boxResponse.addClass("error");
        _$boxResponse.removeClass("success");

        _$boxResponse.find("span").html(errorText.error);
        _$boxResponse.slideDown(350);

        setTimeout(function () {
          _$boxResponse.slideUp(350);
        }, 3500);
      }
    }

    // Verifica se há popup de compra rápida ativo. Se tiver, fecha ele, retirar ou comentar se não for utilizado
    const popupPurchase = document.querySelector('[data-popup-purchase]');
    if (popupPurchase != null) {
      if (popupPurchase.classList.contains('-active')) {
        popupPurchase.querySelector('[data-close-popup-purchase]').click();
      }
    }
  },
  debounce: function (func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  },
  throttle: function (fn, threshhold, scope) {
    threshhold || (threshhold = 250);
    var last, deferTimer;
    return function () {
      var context = scope || this;

      var now = +new Date(),
        args = arguments;
      if (last && now < last + threshhold) {
        // hold on to it
        clearTimeout(deferTimer);
        deferTimer = setTimeout(function () {
          last = now;
          fn.apply(context, args);
        }, threshhold);
      } else {
        last = now;
        fn.apply(context, args);
      }
    };
  },
  setFullbanner: function () {
    $(".fullbanner").each(function (index, el) {
      var $el = $(el);
      var qtdItems = $el.find("[data-item]").length;

      var swiper = new Swiper($(el), {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: $(el).find(".swiper-button-next"),
          prevEl: $(el).find(".swiper-button-prev"),
          disabledClass: "-disabled",
        },
        //swiper lazy load
        preloadImages: false,
        watchVisibility: true,
        lazy: {
          loadPrevNext: false,
          loadOnTransitionStart: true
        }
      });
    });
  },
  trocaImagemProduto: function () {
    $("[data-image-variant]").on("click", function () {
      //console.log($(this));
      var src = $(this).data("image-variant");
      //console.log(src);
      var $produto = $(this).closest(".product-block ");
      //console.log($produto);
      $produto.find(".images").find("img").attr("src", src);
      //console.log($produto.find('.images').find('img'));
    });
  },
  setCarrosselProdutos: function () {
    $(".produtos").each(function (index, el) {
      var $this = $(this);
      var swiper = new Swiper($(el).find("[data-produtos]"), {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: false,
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 40,
          },
        },
        scrollbar: {
          el: $(el).find(".swiper-scrollbar"),
          draggable: true,
        },
        autoplay: {
          delay: 3000,
        },
      });
    });
  },
  setBacktop: function () {
    var $backtop = $("[data-scroll-top]");

    if ($backtop) {
      document
        .querySelector("[data-scroll-top]")
        .addEventListener("click", function (e) {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        });
      $(document).ready(function () {
        $(window).on("scroll", function () {
          if ($(window).scrollTop() >= 10) {
            $backtop.addClass("active");
          } else {
            $backtop.removeClass("active");
          }
        });
      });
    }
  },
  elementInViewport: function (el) {
    //console.log('el', el.offset())

    var top = el.offset().top;
    var left = el.offset().left;
    var width = el.outerWidth();
    var height = el.outerHeight();

    //console.log('top', top)
    //console.log('left', left)
    //console.log('width', width)
    //console.log('height', height)

    //console.log('window.pageYOffset', window.pageYOffset)
    //console.log('window.pageXOffset', window.pageXOffset)

    return (
      top >= window.pageYOffset &&
      left >= window.pageXOffset &&
      top + height <= window.pageYOffset + window.innerHeight &&
      left + width <= window.pageXOffset + window.innerWidth
    );
  },
  setHeaderAttrMobile: function () {
    var atributos = document.querySelectorAll("[data-top-attr]");

    atributos.forEach(attr => {
      attr.addEventListener("click", () => {
        attr.classList.toggle("-active");
      })
    })
  },
  setIconsSlider: function () {
    let sliders = document.querySelectorAll("[data-slider-revistas]");

    sliders.forEach((slider) => {
      var slider = new Swiper(slider, {
        slidesPerView: 2,
        spaceBetween: 15,
        watchOverflow: true,
        autoHeight: true,
        watchSlidesProgress: true,
        autoplay: true,
        loop: false,
        navigation: {
          nextEl: slider.parentNode.querySelector(".swiper-button-next"),
          prevEl: slider.parentNode.querySelector(".swiper-button-prev"),
        },
        scrollbar: {
          el: slider.parentNode.querySelector(".swiper-scrollbar"),
          draggable: true,
        },
        breakpoints: {
          425: {
            slidesPerView: 4,
          },
          767: {
            slidesPerView: 9,
          },
        },
      });
    });
  },
  setFooterTrustvoxSeal: function () {
    function isInViewport(element, percentVisible) {
      let rect = element.getBoundingClientRect();
      let windowHeight = (window.innerHeight || document.documentElement.clientHeight);
      const percentFromTop = Math.floor(100 - (((rect.top >= 0 ? 0 : rect.top) / +-(rect.height / 1)) * 100));
      const percentToBottom = Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100);
      return percentFromTop < percentVisible || percentToBottom > percentVisible;
    }
    const certificate = document.querySelector('[data-trustvox-certificate-fixed]');
    if (certificate) {
      const scriptInterval = setInterval(() => {
        if (isInViewport(certificate, 0)) {
          let newScript = document.createElement('script');
          newScript.setAttribute('src', '//certificate.trustvox.com.br/widget.js');

          document.body.appendChild(newScript);
          certificate.classList.add('-loaded');

          clearInterval(scriptInterval);
        }
      }, 100);
    }
  },
  fixTrustvoxImgs: function () {
    let section = document.querySelector('.-trustvox');
    if (section) {
      let observer = new MutationObserver(mutation => {
        const imgs = section.querySelectorAll('img');
        if (imgs.length > 0) {
          imgs.forEach(img => {
            img.setAttribute('width', img.clientWidth);
            img.setAttribute('height', img.clientHeight);
          });
        }
      });
      observer.observe(section, { attributes: false, childList: true, subtree: true });
    }
  },
  home: {
    init: function () {
      template_store.setFullbanner();
      template_store.setIconsSlider();

      $(".produtos-tabs .links a").on("click", function (e) {
        e.preventDefault();
        $(".produtos-tabs .links a").removeClass("active");
        $(this).addClass("active");
        var tag = $(this).attr("href");
        $(".produtos-tabs .produtos").removeClass("active");
        $('[data-tag="' + tag + '"]').addClass("active");

        $(".produtos").each(function (index, el) {
          var $this = $(this);
          var swiper = new Swiper($(el).find("[data-produtos]"), {
            slidesPerView: 1,
            spaceBetween: 0,
            breakpoints: {
              640: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 40,
              },
            },
            scrollbar: {
              el: $(el).find(".swiper-scrollbar"),
              draggable: true,
            },
            autoplay: {
              delay: 3000,
            },
          });
        });
      });
    },
  },
  product: {
    $sectionProduct: $("[data-section-product]"),
    $wrapperImages: $("[data-section-product]").find("[data-product-images]"),
    $sliderProduct: $("[data-section-product]").find(
      "[data-product-images] [data-main-slider]"
    ),
    $thumbsProduct: $("[data-section-product]").find(
      "[data-product-images] [data-slider-thumbs]"
    ),
    sliderProduct: [],
    /* 
      Exibe as primeiras imagens do produto
      ** Importante para quando houver imagem por sku **
    */
    showFirstImages: function () {
      var _this = this;
      var variants = vnda.variants.all();
      var $imagesWithoutSkus = _this.$sliderProduct.find(".image-without-sku");
      var $thumbsWithoutSkus = _this.$thumbsProduct.find(".image-without-sku");

      if ($imagesWithoutSkus.length > 0) {
        /* 
          Todas as imagens sem skus são exibidas sempre
        */

        $imagesWithoutSkus.removeClass("inactive").addClass("active");

        $thumbsWithoutSkus.removeClass("inactive").addClass("active");
      } else {
        /* 
          Percorre todas as variantes
        */
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].main) {
            //console.info(variants[i]);

            // Procura a imagem que contém o sku e a exibe
            _this.$sliderProduct
              .find('[data-image][data-skus-image*="' + variants[i].sku + '"]')
              .addClass("active")
              .removeClass("inactive");

            _this.$thumbsProduct
              .find(
                '[data-image-thumb][data-skus-image*="' + variants[i].sku + '"]'
              )
              .addClass("active")
              .removeClass("inactive");
          }
        }
      }
    },
    setGallery: function () {
      var _this = this;
      var gallery = new Swiper(_this.$sliderProduct, {
        slidesPerView: 1,
        spaceBetween: 30,
        watchOverflow: true,
        // autoHeight: true,
        preloadImages: true,
        updateOnImagesReady: true,
        on: {
          slideChange: function () {
            MagicZoom.refresh();
          },
        }
      });

      var galleryThumbs = new Swiper(_this.$thumbsProduct, {
        slidesPerView: 4,
        spaceBetween: 20,
        //watchOverflow: true,
        direction: "vertical",
        navigation: {
          nextEl: $(".wrapper-thumbs").find(".swiper-button-next"),
          prevEl: $(".wrapper-thumbs").find(".swiper-button-prev"),
        },
      });

      this.sliderProduct.push(gallery);
      this.sliderProduct.push(galleryThumbs);

      $("[data-slide-index]").on("click", function () {
        gallery.slideTo($(this).data("slide-index") - 1);
      });
    },
    setCarrosselConjunto: function () {
      var gallery = new Swiper('[data-carrossel-compre-junto]', {
        slidesPerView: 1.2,
        spaceBetween: 10,
        watchOverflow: true,
        preloadImages: true,
        updateOnImagesReady: true,
        simulateTouch: false,
        navigation: {
          nextEl: document.querySelector(".compre-junto .swiper-button-next"),
          prevEl: document.querySelector(".compre-junto .swiper-button-prev"),
          disabledClass: "-disabled",
        },
        breakpoints: {
          640: {
            slidesPerView: 1.3,
            spaceBetween: 10,
          },
        },
      });

    },
    setCarrosselIcones: function () {
      var gallery = new Swiper('[data-carrossel-icones]', {
        slidesPerView: 3,
        spaceBetween: 20,
        watchOverflow: true,
        preloadImages: true,
        updateOnImagesReady: true,
        simulateTouch: false,
        breakpoints: {
          640: {
            slidesPerView: 4,
          },
        },
        navigation: {
          nextEl: document.querySelector(".icones .swiper-button-next"),
          prevEl: document.querySelector(".icones .swiper-button-prev"),
          disabledClass: "-disabled",
        },
      });

    },
    addProductBlock: function () {
      const productWrappers = document.querySelectorAll('[data-form-product-block]');

      const variants = document.querySelectorAll('[data-variant-available]');

      variants.forEach(variant => {
        variant.addEventListener('click', () => {
          const skuInput = variant.parentElement.querySelector('[name="sku"]');
          skuInput.value = variant.dataset.variantSku;
          const btnComprar = variant.parentElement.parentElement.nextElementSibling.querySelector('.add-to-cart-button');
          const textUnavailable = btnComprar.dataset.textUnavailable;
          const textAvailable = btnComprar.dataset.textAvailable;

          this.popupPurchase.setPopupAttribute(variant);

          if (variant.dataset.variantAvailable === "false") {
            btnComprar.dataset.available = false;
            btnComprar.classList.remove("available");
            btnComprar.classList.add("unavailable");
            btnComprar.innerHTML = textUnavailable;
          } else {
            btnComprar.dataset.available = true;
            btnComprar.classList.remove("unavailable");
            btnComprar.classList.add("available");
            btnComprar.innerHTML = textAvailable;
          }
        })
      });


      $(document).on('submit', '[data-form-product-block]', function (event) {
        event.preventDefault();
        // console.log('submit');

        var $form = $(this);

        // console.log($form.serialize());

        var $parent = $form.closest('[data-form-product-block]');

        var respValidated = store.validateFormProduct($form);
        var $boxResponse = $parent.find('.msg-response');

        // console.log(respValidated);

        if (respValidated.validated) {
          // console.log('validated');
          store.addItem($form, $parent, function (_$form, _typeResult, _result, _$boxResponse) {
            template_store.addItemResult(_$form, _typeResult, _result, _$boxResponse);
          });
        } else {
          store.setRespValidateProduct(respValidated, $form, $boxResponse);
        }
      })

      $(window).on('load', function () {
        $('.product-block').each(function (index, el) {
          $(el).find('[data-attribute="1"] .label').first().trigger('click');
        })
      })
    },
    popupPurchase: {
      popupEl: document.querySelector('[data-popup-purchase]'),
      currentOpenProduct: false,

      open: function (productBox) {
        // Salva o produto atual para referência futura
        this.currentOpenProduct = productBox;

        // Clona elementos do produto e referencia o form de compra dele
        const clonedImages = productBox.querySelector('.images').cloneNode(true);
        const clonedName = productBox.querySelector('.name').cloneNode(true);
        const clonedPrice = productBox.querySelector('.wrapper-price').cloneNode(true);
        const purchaseForm = productBox.querySelector('[data-form-product-block]');

        // Joga os elementos do produto dentro do popup
        const contentBox = this.popupEl.querySelector('.product');
        const leftBox = document.createElement('div');
        const rightBox = document.createElement('div');
        let priceWrapper = document.createElement('div');
        priceWrapper.classList.add('price-wrapper');
        priceWrapper.appendChild(clonedPrice);

        leftBox.appendChild(clonedImages);
        rightBox.appendChild(clonedName);
        rightBox.appendChild(clonedPrice);
        rightBox.appendChild(purchaseForm);

        contentBox.appendChild(leftBox);
        contentBox.appendChild(rightBox);

        // Atualiza o componente de preço dentro do popup e exibe
        clonedPrice.setAttribute('data-was-processed', false);

        this.popupEl.classList.add('-active');

      },

      close: function () {
        // CHAMAR UMA ÚNICA VEZ
        // Instancia funcionamento ao clicar no botão de fechar o popup
        const popup = this.popupEl;
        const closeButtons = popup.querySelectorAll(
          '[data-close-popup-purchase]'
        );

        closeButtons.forEach((button) => {
          button.addEventListener('click', () => {
            popup.classList.remove('-active');

            setTimeout(() => {
              // Retorna o formulário para o produto correspondente
              const purchaseForm = popup.querySelector('[data-form-product-block]');
              this.currentOpenProduct.appendChild(
                purchaseForm
              );
              this.currentOpenProduct = false;

              // Limpa os dados do produto do popup
              const popupProductEl = popup.querySelector('.product');
              while (popupProductEl.firstChild) {
                popupProductEl.removeChild(popupProductEl.firstChild);
              }
            }, 300);
          });
        });
      },

      markFirstOption: function (_productBlock) {
        // atributo com dropdown
        if (_productBlock.querySelectorAll('[data-variant-available="true"]').length > 0) {
          _productBlock.querySelectorAll('[data-variant-available="true"]')[0].click();
        } else {
          _productBlock.querySelector('[data-variant-available]').click();
        }

      },
      setPopupAttribute: function (variant) {
        const optionTitle = variant.parentElement.previousElementSibling.querySelector('[data-variant]');
        optionTitle.innerText = variant.innerText.trim();
      },
    },
    responsiveDesc: function () {
      let limitDesc = 174;
      let chars = $("#Descrição").html();
      let charsText = $("#Descrição").text();
      if (charsText.length > limitDesc) {
        let visiblePart = $("<span class='short'> " + charsText.substr(0, limitDesc - 1) + "   </span>");
        let dots = $("<span class='dots'>... </span>");
        let hiddenPart = $("<span class='more'>" + chars + "</span>");
        let readMore = $("<span class='read-more'>+</span>");

        readMore.on('click', function () {
          $(this).prev().remove(); // remove dots
          $(this).prev().remove(); // remove descrição curta
          $(this).next().show(); // mostra descrição completa
          $(this).remove(); // remove readMore
        });

        $("#Descrição").empty()
          .append(visiblePart)
          .append(dots)
          .append(readMore)
          .append(hiddenPart);
      }
    },
    waitStars: function () {
      const stars = document.querySelector('[data-trustvox-stars]');
      if (stars) {
        function isInViewport(element, percentVisible) {
          let rect = element.getBoundingClientRect();
          let windowHeight = (window.innerHeight || document.documentElement.clientHeight);
          const percentFromTop = Math.floor(100 - (((rect.top >= 0 ? 0 : rect.top) / +-(rect.height / 1)) * 100));
          const percentToBottom = Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100);
          return percentFromTop < percentVisible || percentToBottom > percentVisible;
        }
        const scriptInterval = setInterval(() => {
          if (isInViewport(stars, 0)) {
            let newScript1 = document.createElement('script');
            newScript1.setAttribute('src', '//static.trustvox.com.br/sincero/sincero.js');
            let newScript2 = document.createElement('script');
            newScript2.setAttribute('src', '//rate.trustvox.com.br/widget.js');

            document.body.appendChild(newScript1);
            document.body.appendChild(newScript2);

            clearInterval(scriptInterval);
          }
        }, 100);
      }
    },
    setBuyTogetherSlider: function () {
      const buyTogetherSlider = document.querySelector('[data-buy-together-slider]');

      if (buyTogetherSlider) {
        const swiperContainer = document.querySelector('[data-buy-together-slider] .swiper-container');
        const slides = swiperContainer.querySelectorAll('.swiper-slide');
        const qtdSlides = slides.length

        var slider = new Swiper(swiperContainer, {
          slidesPerView: qtdSlides,
          // slidesPerView: slides.length > 1 ? 3 : 1,
          navigation: {
            nextEl: buyTogetherSlider.querySelector('.swiper-button-next'),
            prevEl: buyTogetherSlider.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            320: {
              slidesPerView: slides.length > 1 ? 2 : 1,
            },
            992:{
              slidesPerView: 3,
              spaceBetween: 40
            }
          }
        });

        console.log('slider: ', slider);
      }
    },
    init: function () {
      var _this = this;

      _this.showFirstImages();
      _this.setGallery();
      _this.setCarrosselConjunto();
      _this.setCarrosselIcones();
      _this.addProductBlock();
      _this.responsiveDesc();
      _this.waitStars();
      Shipping.init();
      _this.setBuyTogetherSlider();

      let products = document.querySelectorAll('[data-form-product-block]');

      _this.popupPurchase.close();

      products.forEach(product => {
        _this.popupPurchase.markFirstOption(product);

        const openPopupPurchaseButton = product.parentElement.querySelector('[data-open-popup-purchase]');
        if (openPopupPurchaseButton != null) {
          openPopupPurchaseButton.addEventListener('click', () => {
            _this.popupPurchase.open(product.parentElement);
          });
        }
      });


      $(".tabs .tab").on("click", function (e) {
        e.preventDefault();
        var id = $(this).attr("href");
        if (id == '#Descrição' && $(id).height() == 0) {
          var height = 'auto';
          $(id).css("height", height);
          $(this).addClass("active");

        } else if ($(id).height() == 0) {
          var height = $(id).find("div").height() + 15;
          $(id).css("height", height);
          $(this).addClass("active");
        }
        else {
          $(id).css("height", 0);
          $(this).removeClass("active");
        }
      });

      $(".tabs .tab")[0].click();

      $(".description .tabs a").on("click", function (e) {
        e.preventDefault();
        var id = $(this).attr("href");

        $(".description .tabs a").removeClass("active");
        $(this).addClass("active");

        $(".description .content").removeClass("active");
        $(id).addClass("active");
      });

      $(document).on(
        "click",
        '[data-action="minus-quantity-size"]',
        function (event) {
          var $inputQtd = $wrapper.find("[data-input-quantity]");
          var valQtd = parseInt($inputQtd.val());
          if (valQtd - 1 >= 0) {
            $inputQtd.val(valQtd - 1).trigger("change");
          }
        }
      );

      $(document).on(
        "click",
        '[data-action="plus-quantity-size"]',
        function (event) {
          var $inputQtd = $wrapper.find("[data-input-quantity]");
          var valQtd = parseInt($inputQtd.val());

          $inputQtd.val(valQtd + 1).trigger("change");
        }
      );

      $(document).on(
        "submit",
        store.config.selectorFormProduct,
        function (event) {
          event.preventDefault();

          var $form = $(this);
          var $parent = $form.closest(store.config.selectorWrapperProduct);

          var $btnComprar = $parent.find(store.config.selectorBtnBuy);

          var respValidated = store.validateFormProduct($form);
          var $boxResponse = $parent.find(".resp-validate");

          if (respValidated.validated) {
            store.addItem($form, $parent);
          } else {
            //console.info('não foi');
            store.setRespValidateProduct(respValidated, $form, $boxResponse);
          }
        }
      );
    },
  },
  tag: {
    setDescription: function () {
      const tagDescription = document.querySelector('[data-tag-description]');
      if (tagDescription) {
        let anchor = tagDescription.querySelector('.anchor');
        anchor.addEventListener('click', (e) => {
          e.preventDefault();

          if (tagDescription.classList.contains('-active')) {
            tagDescription.classList.remove('-active');
            anchor.innerText = 'Ver mais'
          } else {
            tagDescription.classList.add('-active');
            anchor.innerText = 'Ver menos'
          }
        });
      }
    },
    init: function () {
      this.setDescription();
    },
  },
  login: {
    init: function () {
      $("[data-content-login]").each(function (index, el) {
        // Animação
        $(el).on("click", "[data-forget-password]", function (event) {
          event.preventDefault();
          $(el).find(".wrapper-form-login").animate({ height: "toggle" }, 500);
          $(el)
            .find(".wrapper-form-recover")
            .animate({ height: "toggle" }, 500);
        });

        $(el).on("click", "[data-forget-password-back]", function (event) {
          event.preventDefault();
          $(el).find(".wrapper-form-login").animate({ height: "toggle" }, 500);
          $(el)
            .find(".wrapper-form-recover")
            .animate({ height: "toggle" }, 500);
        });

        $(el).on("submit", "[data-form-login]", function (event) {
          event.preventDefault();

          var $form = $(this);
          var respValidated = store.login.validateLogin($form);

          if (respValidated.validated) {
            store.login.logar($form);
          } else {
            store.setMsgResponse(respValidated.errors, "error", $(this));
          }
        });

        $(el).on("submit", "[data-form-register]", function (event) {
          event.preventDefault();

          var $form = $(this);
          var respValidated = store.login.validateRegister($form);

          if (respValidated.validated) {
            store.login.logar($form);
          } else {
            store.setMsgResponse(respValidated.errors, "error", $(this));
          }
        });

        $(el).on("submit", "[data-form-recover]", function (event) {
          event.preventDefault();

          var $form = $(this);
          var respValidated = store.login.validateRecover($form);

          if (respValidated.validated) {
            store.login.recoverPassord($form);
          } else {
            store.setMsgResponse(respValidated.errors, "error", $(this));
          }
        });
      });
    },
  },
  page: {
    init: function () {
      template_store.setIconsSlider();
      $(document).ready(function () {
        var hash_url = document.location.hash;
        if (hash_url != "") {
          var scr = $(hash_url).offset().top - 100;
          $("body").animate(
            {
              scrollTop: scr,
            },
            1000
          );
        }
      });
    },
  },

  initGTM: function () {
    window.addEventListener('load', () => {
      // afterLoad
      // try {
      //   console.log('GTM afterLoad!');
      //   window.setTimeout(() => { if (dataLayer) dataLayer.push({'event' : 'afterLoad'}) }, 1500);
      // } catch (error) {
      //   console.log('GTM afterLoad error', error);
      // }
      // Jivochat
      let hasJivochat = false;
      const addJivochat = function () {
        if (hasJivochat) return;
        let newScript = document.createElement('script');
        newScript.setAttribute('src', '//code.jivosite.com/widget/q4SfRQvDo8');
        document.body.appendChild(newScript);
        hasJivochat = true;
        console.log('GTM Jivochat!');

        window.removeEventListener('mousemove', addJivochat);
        window.removeEventListener('scroll', addJivochat);
      }
      window.addEventListener('mousemove', addJivochat);
      window.addEventListener('scroll', addJivochat);
    });
  },

  init: function () {
    template_store.fixTrustvoxImgs();
    template_store.setMenuMobile();
    template_store.trocaImagemProduto();
    template_store.setCarrosselProdutos();
    template_store.setBacktop();
    template_store.setHeaderAttrMobile();
    template_store.setFooterTrustvoxSeal();
    template_store.headerCart.loadCart();
    store.updateCartCount(store.getCartCount())

    // COMPONENTS
    // Zendesk();
    RDStation();
    widgetWhatsapp();

    // ENVIO DE FORMULÁRIOS
    Webforms.init();

    if ($(window).width() > 767) {
      $(window).scroll(function (event) {
        if ($(window).scrollTop() > 147) {
          $("header.floating-top").addClass("open");
        } else {
          $("header.floating-top").removeClass("open");
        }
      });
    }

    var swiper = new Swiper($(".atributos").find(".swiper-container"), {
      slidesPerView: 2,
      spaceBetween: 0,
      autoplay: {
        delay: 3000,
      },
      navigation: {
        nextEl: $(".atributos").find(".swiper-button-next"),
        prevEl: $(".atributos").find(".swiper-button-prev"),
        disabledClass: "-disabled",
      },
    });

    $(".submenu [data-image]").mouseenter(function () {
      var imagem = $(this).data("image");
      //console.log(imagem)

      $(this).closest(".submenu").find(".image img").attr("src", imagem);
    });

  },
};

$(function () {
  window.template_store.init();

  if (page == "home" || window.location.pathname == '/p/debug') {
    template_store.home.init();
  }

  if (page == "product") {
    template_store.product.init();
  }

  if (page == "tag") {
    template_store.tag.init();
  }

  if (page == "login") {
    template_store.login.init();
  }

  if (page == "page") {
    template_store.page.init();
  }
});

$(window).on("load", function () {
  $("body").removeClass("window-loading");
});

console.log(
  "%cVnda - Tecnologia em Ecommerce",
  'color: #f88d5b; font-size: 15px; font-family: "Verdana", sans-serif; font-weight: bold;'
);
